import { useSelector } from 'react-redux';

const orgDataSelector = (state) => state.orgData.okrConfigData;

const useOKRConfig = () => {
  const okrConfigData = useSelector(orgDataSelector) || {};

  const {
    OBJECTIVE_TYPE,
    DEFAULT_KR_PROGRESS,
    DEFAULT_KR_VISIBILITY,
    IS_KR_CASCADING_ENABLED,
    DEFAULT_OBJECTIVE_PROGRESS,
    ENABLE_IMPORTANCE_IN_GOALS,
    DEFAULT_OBJECTIVE_VISIBILITY,
  } = okrConfigData || {};

  return {
    OBJECTIVE_TYPE: OBJECTIVE_TYPE?.value,
    DEFAULT_KR_PROGRESS: DEFAULT_KR_PROGRESS?.value,
    DEFAULT_KR_VISIBILITY: DEFAULT_KR_VISIBILITY?.value,
    IS_KR_CASCADING_ENABLED: IS_KR_CASCADING_ENABLED?.value === 'true',
    DEFAULT_OBJECTIVE_PROGRESS: DEFAULT_OBJECTIVE_PROGRESS?.value,
    ENABLE_IMPORTANCE_IN_GOALS: ENABLE_IMPORTANCE_IN_GOALS?.value === 'true',
    DEFAULT_OBJECTIVE_VISIBILITY: DEFAULT_OBJECTIVE_VISIBILITY?.value,
  };
};

export default useOKRConfig;
